<div
    [class]="class()"
    [class.text-label]="true"
    [class.inline]="inline()"
    [class.no-margin]="noMargin()"
    [class.small]="size() === 'small'"
    [class.large]="size() === 'large'">
    <label [for]="label()" [style.min-width]="labelMinWidth()">
        {{ computedLabel() }}
        @if (infoTooltipText() && label()) {
            <info-tooltip [id]="label() + '-info-tooltip'" [text]="infoTooltipText()"></info-tooltip>
        }
    </label>

    @if (redirectUrl()) {
        <a [href]="redirectUrl()" target="_blank">
            <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
        </a>
    } @else if (routerLink()) {
        <a [routerLink]="routerLink()" [queryParams]="routerQueryParams()">
            <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
        </a>
    } @else {
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
    }
</div>

<ng-template #contentTemplate>
    @if (dateTime()) {
        <date-and-time [dateTime]="dateTime()" [showTime]="showTime()"></date-and-time>
    } @else {
        @if (!textBlock()) {
            @if (computedText()) {
                <div ellipsis-tooltip [id]="label() || ''">
                    <span>{{ computedText() | translate }}</span>
                </div>
            }
        } @else {
            <text-block
                [text]="computedText()"
                [maxHeight]="textBlockMaxHeight()"
                [innerHTML]="innerHtml()"></text-block>
        }
    }
</ng-template>
